import { render, staticRenderFns } from "./HelpusTab.vue?vue&type=template&id=cad99b36&scoped=true"
import script from "./HelpusTab.vue?vue&type=script&lang=js"
export * from "./HelpusTab.vue?vue&type=script&lang=js"
import style0 from "./HelpusTab.vue?vue&type=style&index=0&id=cad99b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad99b36",
  null
  
)

export default component.exports